import axios from 'axios'
import {
	MessageBox,
} from 'element-ui'
import router from './src/router/index.js';
import {
	Message
} from 'element-ui';
import {
	Loading
} from 'element-ui';
axios.defaults.timeout = 600000; //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8'; //配置请求头
import backjson from './src/db.json'
import configHttp from './configHttp.js'
// axios.defaults.baseURL = 'http://192.168.1.54:8989/epj/';  //配置接口地址 */
// axios.defaults.baseURL = 'http://192.168.1.54:8989/epj/';  //配置接口地址 */

// axios.defaults.baseURL = 'http://192.168.1.46:8989/epj/';  //配置接口地址 */

//var baseURL='http://localhost:8082/ei/'
//var baseURL='https://sit.taxunion.com.cn:8443/ei/'
let baseURL = configHttp.baseURL;
axios.defaults.baseURL = configHttp.baseURL; //配置接口地址 */
//axios.defaults.baseURL = 'http://192.168.1.12:8082/ei/';  //配置接口地址





//axios.defaults.baseURL = 'https://aussiebit.com.au:8096'; //配置接口地址
//POST传参序列化(添加请求拦截器)
/* axios.interceptors.request.use((config) => {
    //在发送请求之前做某件事
    if(config.method  === 'post'){
        config.data = qs.stringify(config.data);
    }
    return config;
},(error) =>{
    console.log('错误的传参')
    return Promise.reject(error);
});

 */


//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
	//对响应数据做些事
	if (!res.data.success) {
		return Promise.resolve(res);
	}
	return res;
}, (error) => {
	return Promise.reject(error);
});
var loadingCount = 0

function closeloading(loading) {
	loadingCount--
	console.log(loadingCount)
	if (loadingCount == 0) {
		loading.close()

	}
}

function showloading(Loading) {
	var loading = Loading.service({
		lock: true,
		text: 'loading……',
		background: 'rgba(0, 0, 0, 0.7)'
	})
	loadingCount++
	return loading
}
//返回一个Promise(发送post请求)
export function fetchPost(url, params) {
	var token = localStorage.getItem('token')
	if (url != "/doc/updateInvoiceStatus" && url != "/doc/openInvoice" && url != '/invoice/issueInfo/getDocList') {
		// var loading = Loading.service({
		// 	lock: true,
		// 	text: 'loading……',
		// 	background: 'rgba(0, 0, 0, 0.7)'
		// })
		var loading = showloading(Loading)
	}
	if (token != "" & token != null) {
		axios.defaults.headers.common['token'] = token

	}
	return new Promise((resolve, reject) => {
		axios.post(url, params)
			.then(response => {
				function notemptyandnull(stirng) {
					if (stirng != "" & stirng != null) {
						return true
					} else {
						return false
					}
				}

				function emptyandnull(stirng) {
					if (stirng == "" || stirng == null) {
						return true
					} else {
						return false
					}
				}
				if (response.data.code == "2018" && url != "/register") {
					var portalLogin = localStorage.getItem("portalLogin");
					if (portalLogin && portalLogin == 'true') {
						router.push('/portalLogin');
					} else {
						router.push('/login');
					}
					closeloading(loading);
					localStorage.clear();
					localStorage.setItem("portalLogin", portalLogin);
					loading.close();
					return;
				}
				if (notemptyandnull(response.data.code) &&
					url !== 'redLetter/getRealDocInfo' &&
					url !== '/page/data/report/monthlyInvoiceAmountStatistics' &&
					url !== '/page/data/report/monthlyInvoiceNumberStatistics' &&
					url !== 'invoice/issueInfo/getCurHdkpsl' &&
					url !== '/doc/audit' &&
					url !== 'sys/admin/getRoleMenuFunctionList' &&
					url !== 'sys/admin/getUserListByRole' &&
					url !== 'sys/admin/getMenuIdListByRole' &&
					url !== 'qrcode/getQrCodeDataInfo' &&
					url !== '/master/getAllCustomerList' &&
					url !== 'sys/register/doRegister' &&
					url !== '/master/getInvoiceCustomerList' &&
					url !== '/master/getInvoiceGoodsList' &&
					url !== '/invoice/issueInfo/saveAppDoc' &&
					url !== '/redLetter/doRedLetter' &&
					url !== '/redLetter/getRealDocInfo' &&
					url !== '/redLetter/getProcessvalue' &&
					url !== 'felec/addInformMaintain/addAddInformItem' &&
					url !== 'felec/addInformMaintain/getAddInformItemList' &&
					url !== 'felec/addInformMaintain/updateAddInformItem' &&
					url !== 'felec/addInformMaintain/deleteAddInformItems' &&
					url !== 'felec/addInformMaintain/getAddInformItemByCode' &&
					url !== 'felec/addInformMaintain/addScenarioTemplate' &&
					url !== 'felec/addInformMaintain/getScenarioTemplateList' &&
					url !== 'felec/addInformMaintain/updateScenarioTemplate' &&
					url !== 'felec/manual/getDocList/toBeInvoiced' &&
					url !== 'felec/positiveInvoice/getDocList' &&
					url !== 'felec/manual/getDocList/rewrite' &&
					url !== 'felec/manual/formatImport/result' &&
					url !== 'felec/manual/manualImport/result' &&
					url !== 'felec/addInformMaintain/getScenarioTemplatesByCode' &&
					url !== 'felec/positiveInvoice/saveOrUpdateDoc' &&
					url !== 'sys/admin/getAgentByCode' &&
					url !== 'felec/positiveInvoice/getDocInformById' &&
					url !== 'felec/positiveInvoice/getIsAutomaticAudit' &&
					url !== 'felec/positiveInvoice/updateIsAutomaticAudit' &&
					url !== 'felec/positiveInvoice/mergeSameCustomer' &&
					url !== 'felec/positiveInvoice/cancelAudit' &&
					url !== 'felec/positiveInvoice/delDoc' &&
					url !== 'felec/positiveInvoice/audit' &&
					url !== 'felec/addInformMaintain/deleteScenarioTemplate' &&
					url !== '/felec/positiveInvoice/docConversion' &&
					url !== 'felec/positiveInvoice/getDocInformByDocument' &&
					url !== 'rule/getCurrProject' &&
					url !== '/page/data/report/getDocInventoryQueryPojoByCompanyList' &&
					url !== '/natural/codeAssignment/findCodeAssignment' &&
					url !== '/natural/codeAssignment/operatorCodeAssignmentConfig' &&
					url !== '/natural/credit/findLineCredit' &&
					url !== '/page/data/report/getTaxReturnsMonitoringDataByCompanyList' &&
					url !== '/natural/credit/updateLineCredit' &&
					url !== '/natural/credit/findCreditConfig' &&
					url !== '/natural/credit/operatorLineCreditThresholdConfig' &&
					url !== '/natural/codeAssignment/findCodeAssignmentConfig' &&
					url !== '/natural/codeAssignment/findCodeAssignmentDetail' &&
					url !== '/natural/codeAssignment/findCodeAssignmentRecords' &&
					url !== '/natural/codeAssignment/findAvailableStock' &&
					url !== '/natural/basicInfo/updateNaturalBaSicInfo' &&
					url !== '/natural/basicInfo/findNaturalBasicInfo' &&
					url !== '/natural/risk/updateNaturalBaSicInfo' &&
					url !== '/natural/risk/findNaturalRisk' &&
					url !== '/natural/taxRate/findAvailableTaxRate' &&
					url !== '/natural/taxRate/updateAvailableTaxRate' &&
					url !== '/schedule/query' &&
					url !== '/schedule/getTaskList' &&
					url !== '/schedule/add' &&
					url !== '/schedule/update' &&
					url !== 'schedule/record' &&
					url !== '/schedule/summary/invoice/upload/query' &&
					url !== '/schedule/summary/invoice/usageStatus/query' &&
					url !== '/master/getGoodsSwbmListNew' &&
					url !== '/master/getGoodsSWBMTree' &&
					url !== '/felec/positiveInvoice/getIsAutomaticAudit' &&
					url !== '/felec/positiveInvoice/openInvoice' &&
					url !== '/master/refreshGoodsSwbmData' &&
					url !== '/master/getRefreshGoodsSwbmTime' &&
					url !== '/page/data/report/natural/getCurrentMonthInvoiceInfo'&&
					url !== '/page/data/report/natural/getInvoiceRecentPending'&&
					url !== '/page/data/report/natural/invoiceAmountTrendData'&&
					url !== '/page/data/report/natural/invoiceNumTrendData'&&
					url !== '/page/data/report/natural/summaryOfGroupInvoiceInformation'&&
					url !== '/rpa/authentication/getPhoneMessage/v2' &&
					url !== '/rpa/authentication/authCodeLogin/v2' &&
					url !== '/rpa/authentication/getQrCode/v2' &&
					(url.indexOf('?') == -1)
				) {
					console.log(url)
					if (url !== '/master/getGoodsSWBMTree' && url !==
						'/felec/positiveInvoice/openInvoice') {
						if (response.data.success) {
							Message.success(backjson[response.data.code]);
						} else {
							if (backjson[response.data.code]) {
								Message.error(backjson[response.data.code]);
							} else {
								Message.error(response.data.message);
							}
						}
					}
				} else if (emptyandnull(response.data.code) & notemptyandnull(response.data.message)) {
					if (url !== '/doc/openInvoice' &&
						url !== '/felec/positiveInvoice/openInvoice' &&
						url !== '/page/data/report/monthlyInvoiceAmountStatistics' &&
						url !== '/felec/positiveInvoice/docConversion' &&
						url !== '/page/data/report/monthlyInvoiceNumberStatistics' &&
						url !== 'felec/positiveInvoice/delDoc' &&
						url !== 'felec/positiveInvoice/audit' &&
						url !== 'felec/positiveInvoice/cancelAudit' &&
						url !== 'felec/positiveInvoice/mergeSameCustomer' &&
						url !== '/tax/copy/manage/init/data' &&
						url !== 'redLetter/getRealDocInfo' &&
						url !== '/invoice/issueInfo/getCurHdkpsl' &&
						url !== 'inventory/syncDistribute' &&
						url !== 'inventory/syncDistributeAlarm' &&
						url !== 'inventory/getDistributeAlarmMessage' &&
						url !== '/doc/audit' &&
						url !== 'sys/admin/getRoleMenuFunctionList' &&
						url !== 'sys/admin/getUserListByRole' &&
						url !== 'sys/admin/getMenuIdListByRole' &&
						url !== 'qrcode/getQrCodeDataInfo' &&
						url !== '/master/getAllCustomerList' &&
						url !== 'sys/register/doRegister' &&
						url !== '/master/getInvoiceCustomerList' &&
						url !== '/master/getInvoiceGoodsList' &&
						url !== '/invoice/issueInfo/saveAppDoc' &&
						url !== '/redLetter/doRedLetter' &&
						url !== '/redLetter/getProcessvalue' &&
						url !== 'felec/addInformMaintain/addAddInformItem' &&
						url !== 'felec/addInformMaintain/getAddInformItemList' &&
						url !== 'felec/addInformMaintain/updateAddInformItem' &&
						url !== 'felec/addInformMaintain/deleteAddInformItems' &&
						url !== 'felec/addInformMaintain/getAddInformItemByCode' &&
						url !== 'felec/addInformMaintain/addScenarioTemplate' &&
						url !== 'felec/addInformMaintain/getScenarioTemplateList' &&
						url !== 'felec/addInformMaintain/updateScenarioTemplate' &&
						url !== 'felec/manual/getDocList/toBeInvoiced' &&
						url !== 'felec/positiveInvoice/getDocList' &&
						url !== 'felec/manual/getDocList/rewrite' &&
						url !== 'felec/manual/formatImport/result' &&
						url !== 'felec/manual/manualImport/result' &&
						url !== 'felec/positiveInvoice/saveOrUpdateDoc' &&
						url !== 'sys/admin/getAgentByCode' &&
						url !== 'felec/positiveInvoice/getDocInformById' &&
						url !== 'felec/positiveInvoice/getIsAutomaticAudit' &&
						url !== 'felec/positiveInvoice/updateIsAutomaticAudit' &&
						url !== 'felec/addInformMaintain/getScenarioTemplatesByCode' &&
						url !== 'felec/addInformMaintain/deleteScenarioTemplate' &&
						url !== 'felec/positiveInvoice/getDocInformByDocument' &&
						url !== '/page/data/report/getDocInventoryQueryPojoByCompanyList' &&
						url !== '/natural/codeAssignment/findCodeAssignment' &&
						url !== '/natural/codeAssignment/operatorCodeAssignmentConfig' &&
						url !== '/natural/credit/findLineCredit' &&
						url !== '/page/data/report/getTaxReturnsMonitoringDataByCompanyList' &&
						url !== '/natural/credit/updateLineCredit' &&
						url !== '/natural/credit/findCreditConfig' &&
						url !== '/natural/credit/operatorLineCreditThresholdConfig' &&
						url !== '/natural/codeAssignment/findCodeAssignmentConfig' &&
						url !== '/natural/codeAssignment/findCodeAssignmentDetail' &&
						url !== '/natural/codeAssignment/findCodeAssignmentRecords' &&
						url !== '/natural/codeAssignment/findAvailableStock' &&
						url !== '/natural/basicInfo/updateNaturalBaSicInfo' &&
						url !== '/natural/basicInfo/findNaturalBasicInfo' &&
						url !== '/natural/risk/updateNaturalBaSicInfo' &&
						url !== '/natural/risk/findNaturalRisk' &&
						url !== '/natural/taxRate/findAvailableTaxRate' &&
						url !== '/natural/taxRate/updateAvailableTaxRate' &&
						url !== '/schedule/query' &&
						url !== '/schedule/getTaskList' &&
						url !== '/schedule/add' &&
						url !== '/schedule/update' &&
						url !== 'schedule/record' &&
						url !== '/schedule/summary/invoice/upload/query' &&
						url !== '/schedule/summary/invoice/usageStatus/query' &&
						url !== '/master/getGoodsSwbmListNew' &&
						url !== '/master/getGoodsSWBMTree' &&
						url !== '/felec/positiveInvoice/getIsAutomaticAudit' &&
						url !== '/master/refreshGoodsSwbmData' &&
						url !== '/master/getRefreshGoodsSwbmTime' &&
						url !== '/rpa/authentication/getPhoneMessage/v2' &&
						url !== '/rpa/authentication/authCodeLogin/v2' &&
						url !== '/rpa/authentication/getQrCode/v2' &&
						(url.indexOf('?') == -1)
					) {
						if (response.data.success) {
							Message.success(response.data.message);
						} else {
							Message.error(response.data.message);
						}
					}

				}
				if (url != "/doc/updateInvoiceStatus" && url != "/doc/openInvoice" && url !=
					'/invoice/issueInfo/getDocList') {
					loading.close();
				}
				resolve(response);
			}, err => {
				reject(err);
				loading.close();
			})
			.catch((error) => {
				reject(error);
				loading.close();
			})
	})
}
////返回一个Promise(发送get请求)
export function fetchGet(url, param) {
	// const loading = Loading.service({
	// 	lock: true,
	// 	text: 'loading……',
	// 	background: 'rgba(0, 0, 0, 0.7)'
	// })
	var loading = showloading(Loading)
	var token = localStorage.getItem('token')
	if (token != "" & token != null) {
		axios.defaults.headers.common['token'] = token

	}

	function notemptyandnull(stirng) {
		if (stirng != "" & stirng != null) {
			return true
		} else {
			return false
		}
	}

	function emptyandnull(stirng) {
		if (stirng == "" || stirng == null) {
			return true
		} else {
			return false
		}
	}
	return new Promise((resolve, reject) => {
		axios.get(url, {
				params: param
			})
			.then(response => {
				console.log(url);
				if (notemptyandnull(response.data.code) &&
					url !== '/page/data/report/invoiceAmountTrendData' &&
					url !== '/schedule/getTaskList' &&
					url !== '/page/data/report/invoiceNumTrendData' &&
					url !== 'rpa/refreshFaceCode' &&
					url !== 'rpa/authCodeLogin' &&
					url !== 'rpa/getDigitalRpaInfo' &&
					url !== 'rpa/fastRedPunch' &&
					url !== 'rpa/forceInvoiceIssue' &&
					(url.indexOf('?') == -1)
				) {
					if (response.data.success) {
						Message.success(backjson[response.data.code]);
					} else {
						Message.error(backjson[response.data.code]);
					}
				} else if (emptyandnull(response.data.code) & notemptyandnull(response.data
						.message)) {
					if (url !== '/page/data/report/invoiceAmountTrendData' &&
						url !== '/schedule/getTaskList' &&
						url !== '/page/data/report/invoiceNumTrendData' &&
						url !== 'rpa/refreshFaceCode' &&
						url !== 'rpa/authCodeLogin' &&
						url !== 'rpa/getDigitalRpaInfo' &&
						url !== 'rpa/fastRedPunch' &&
						url !== 'rpa/forceInvoiceIssue' &&
						(url.indexOf('?') == -1)) {
						if (response.data.success) {
							Message.success(response.data.message);
						} else {
							Message.error(response.data.message);
						}
					}

				}
				if (response.data.message == "2018") {
					Message.error("您的登陆状态已失效,请重新登陆")
					var portalLogin = localStorage.getItem("portalLogin");
					if (portalLogin && portalLogin == 'true') {
						router.push('/portalLogin');
					} else {
						router.push('/login');
					}
					closeloading(loading);
					localStorage.clear();
					localStorage.setItem("portalLogin", portalLogin);
					loading.close();
					return;
				}
				loading.close()

				resolve(response)
			}, err => {
				console.log(err)
				reject(err)
				loading.close()
			})
			.catch((error) => {
				console.log(error)
				reject(error)
				loading.close()
			})
	})
}
export function fetchdowload(url, param) {
	// const loading = Loading.service({
	// 	lock: true,
	// 	text: 'loading……',
	// 	background: 'rgba(0, 0, 0, 0.7)'
	// })
	var loading = showloading(Loading)
	var token = localStorage.getItem('token')
	if (token != "" & token != null) {
		axios.defaults.headers.common['token'] = token

	}
	return new Promise((resolve, reject) => {
		axios.post(url, param, {
				responseType: "blob"
			})
			.then(response => {
				if (response.data.code == "2018") {
					Message.error("您的登陆状态已失效,请重新登陆")
					var portalLogin = localStorage.getItem("portalLogin");
					if (portalLogin && portalLogin == 'true') {
						router.push('/portalLogin');
					} else {
						router.push('/login');
					}
					closeloading(loading);
					localStorage.clear();
					localStorage.setItem("portalLogin", portalLogin);
					loading.close();
					return;
				}
				loading.close()

				resolve(response)
			}, err => {
				reject(err)
			})
			.catch((error) => {
				reject(error)
			})
	})
}
export function fetchdowloadget(url, param) {
	// const loading = Loading.service({
	// 	lock: true,
	// 	text: 'loading……',
	// 	background: 'rgba(0, 0, 0, 0.7)'
	// })
	var loading = showloading(Loading)
	var token = localStorage.getItem('token')
	if (token != "" & token != null) {
		axios.defaults.headers.common['token'] = token

	}
	return new Promise((resolve, reject) => {
		axios.get(url, param, {
				responseType: "blob"
			})
			.then(response => {
				if (response.data.code == "2018") {
					Message.error("您的登陆状态已失效,请重新登陆")
					var portalLogin = localStorage.getItem("portalLogin");
					if (portalLogin && portalLogin == 'true') {
						router.push('/portalLogin');
					} else {
						router.push('/login');
					}
					closeloading(loading);
					localStorage.clear();
					localStorage.setItem("portalLogin", portalLogin);
					loading.close();
					return;
				}
				loading.close()

				resolve(response)
			}, err => {
				reject(err)
			})
			.catch((error) => {
				reject(error)
			})
	})
}

export default {
	fetchPost,
	fetchGet,
	fetchdowload,
	baseURL,
	fetchdowloadget
}
